package kz.dentalcrm.app.screens.appointments.mvi

import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.employees.Employee

sealed interface AppointmentViewEvent : ViewEvent {

    data class LoadData(
        val dateFrom: LocalDate,
        val dateTo: LocalDate,
        val employeeId: String? = null
    ) : AppointmentViewEvent

    data object ReloadData : AppointmentViewEvent

    data class SelectEmployee(val employee: Employee) : AppointmentViewEvent

    data class Delete(val appointmentId: Int) : AppointmentViewEvent

    data class Edit(val appointmentId: Int) : AppointmentViewEvent

    data class OnStatusChanged(val appointmentId: Int, val status: String) : AppointmentViewEvent
}